const preProcessRequestData = data => {
  const {
    isActive,
    createdByUserId,
    lastModifiedByUserId,
    id,
    recordVersion,
    industries,
    ...other
  } = data;
  return {
    isActive: isActive === 'true',
    industries:
      industries?.map(i => {
        return { id: i.value };
      }) || [],
    ...other,
  };
};

const preProcessFetchData = data => {
  const { industries, ...other } = data;
  return {
    ...other,
    industries:
      industries?.map(i => {
        return { label: i.industryName, value: i.id };
      }) || [],
  };
};

const getBrandDataById = async (params, id) => {
  const getPageDataApiUrl = `${params?.getApiUrl()}/sxcl/v1/brands/${id}`;
  const response = await params?.get(getPageDataApiUrl);
  if (response?.ok) {
    return {
      data: preProcessFetchData(response?.data),
      errors: null,
    };
  }
  return {
    data: null,
    errors: response?.errors,
  };
};

export { preProcessRequestData, preProcessFetchData, getBrandDataById };
